export default __webpack_public_path__ + "static/media/icon-doctor-repo.72d282c0.svg";